/**
 * Created by Ning Jiang on 5/2/2019.
 */

import {GameConfig} from "@nolimitcity/slot-game/bin/core/gameconfig/GameConfig";
import {ISymbolSizeConfig, ISymbolStateConfig} from "@nolimitcity/slot-game/bin/core/reelsymbol/StateReelSymbol";
import {PixiesVsPiratesReelSymbol} from "./PixiesVsPiratesReelSymbol";

export class PPLowSymbol extends PixiesVsPiratesReelSymbol {

    constructor(symName:string, reelId:number, state?:ISymbolStateConfig, size?:ISymbolSizeConfig) {
        super(symName, reelId, state, size);
    }

    protected updateHeightDisplay():void {
        super.updateHeightDisplay();
        this.scale.set(this._displayScale, this._displayScale);
    }

    protected drawSymMask():boolean {
        this._symMask = new PIXI.Graphics();
        this._symMask.beginFill(0xFF0000, 1);
        this._symMask.drawRect(-GameConfig.instance.SYMBOL_WIDTH / this._displayScale / 2, -GameConfig.instance.SYMBOL_HEIGHT / 2, GameConfig.instance.SYMBOL_WIDTH / this._displayScale, GameConfig.instance.SYMBOL_HEIGHT);
        this._symMask.name = "mask";
        this.addChild(this._symMask);
        this.mask = this._symMask;
        return true;
    }
}